import type { Activity, UUID } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getActivityFeed(patientId: UUID): Promise<Activity[]> {
  const response = await sharedRequestsTyped.get_activity_feed({
    context: { showLoader: false },
    patientId,
  });

  return response.results;
}
